import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
// components
import { IconButton } from 'components/UI'
// static
import ArchiveIconOrigin from 'src/icons/archive.svg'
// utils
import { size } from 'polished'

const ArchiveIcon = styled(ArchiveIconOrigin)`
  && {
    ${size('24px')};
  }
`

const ShowArchivedFieldsButton: React.FC = () => {
  const router = useRouter()

  const showArchivedFields = () => {
    const shouldShowArchived = !router.query.archived

    router.replace({
      pathname: `/forms/templates/edit/${router.query.id}`,
      query: {
        ...(shouldShowArchived && { archived: 'true' })
      }
    })
  }

  return (
    <IconButton
      onClick={showArchivedFields}
      isActive={!!router.query.archived}
      description={router.query.archived ? 'Show Active Fields' : 'Show Archived Fields'}>
      <ArchiveIcon />
    </IconButton>
  )
}

export default ShowArchivedFieldsButton
